<script>
  import { selectedFilterTitle, filterList, filtersData, selectedFilters, isShowClearAction } from '../../store'
  import { selectFilter, applyFilters, resetFilters } from '../../services'
  import MultipleCheckbox from '../../../Create/components/MultipleCheckbox/MultipleCheckbox.svelte'
    import Count from '../Сount/Count.svelte';
    import DatePicker from '../../../../components/DatePicker/DatePicker.svelte';
</script>

<div class="filters">
  <div class="header">
    <div class="header-title">{$selectedFilterTitle}</div>
    <div class="header-actions">
      {#if $isShowClearAction}
        <div class="header-action clear" on:click={resetFilters}>
          {$selectedFilterTitle === 'Фильтры' ? 'Cбросить все' : 'Cбросить'}
        </div>
      {/if}

      <div class="header-action apply" on:click={applyFilters}>
        Применить
      </div>
    </div>
  </div>
  <hr>
  <div class="body">
    {#if $selectedFilterTitle === 'Фильтры' }
      {#each $filterList as { title, value, id } (id) }
        <div class="filter-item" on:click={() => selectFilter({ title, value })}>
          <div class="filter-item-title">
            <div>{title}</div>
            
            {#if $selectedFilters[value].beforeApplyValue?.length}
              <Count count={
                  $selectedFilters[value].beforeApplyValue.filter(Boolean).length
                } 
              />
            {/if}
          </div>

          <i class="icon-chevron-right" />
        </div>
      {/each}
    {/if}

    {#if $selectedFilterTitle === 'По дате'}
        <div class="dates">
          <DatePicker label="Дата начала" bind:value={$selectedFilters.date.beforeApplyValue[0]} />
          <DatePicker label="Дата окончания" bind:value={$selectedFilters.date.beforeApplyValue[1]} />
        </div>
    {/if}

    {#if $selectedFilterTitle === 'По группе'}
      {#each $filtersData.feed_group as item (item.pk) }
        <div class="checkbox">
          <MultipleCheckbox 
            label={item.title} 
            value={item}
            bind:bindGroup={$selectedFilters.group.beforeApplyValue} 
          />
        </div>
      {/each}
    {/if}

    {#if $selectedFilterTitle === 'По потоку'}
      {#each $filtersData.flows as item (item.pk) }
        <div class="checkbox">
          <MultipleCheckbox 
            label={item.title} 
            value={item}
            bind:bindGroup={$selectedFilters.flows.beforeApplyValue} 
          />
        </div>
      {/each}
    {/if}

    {#if $selectedFilterTitle === 'По разделу'}
      {#each $filtersData.publicate_section as item (item.pk) }
        <div class="checkbox">
          <MultipleCheckbox 
            label={item.title} 
            value={item}
            bind:bindGroup={$selectedFilters.sections.beforeApplyValue} 
          />
        </div>
      {/each}
    {/if}

    {#if $selectedFilterTitle === 'По тегу'}
      {#each $filtersData.feed_tag as item (item.pk) }
        <div class="checkbox">
          <MultipleCheckbox 
            label={item.title} 
            value={item}
            bind:bindGroup={$selectedFilters.tags.beforeApplyValue} 
          />
        </div>
      {/each}
    {/if}
  </div>
</div>

<style lang="scss">
  .dates {
    display: grid;
    align-items: center;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;

    * {
      margin-right: 10px;
    }
  }

  .filters {
    height: 475px;
    width: 516px;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0px 1px 12px 0px #30333D2E;
    background-color: white;
    position: absolute;
    right: 0;
    margin-top: 8px;
    overflow-y: scroll;
    overflow-x: hidden;

    .body {
      .checkbox:not(:last-child) {
        margin-bottom: 24px;
      }

      .filter-item {
        border: 1px solid #E0E8F6;
        border-bottom: 0;
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        box-sizing: border-box;
        height: 45px;

        &:first-child {
          border-radius: 4px 4px 0 0;
        }

        &:last-child {
          border-bottom: 1px solid #E0E8F6;
          border-radius: 0 0 4px 4px;
        }

        &-title {
          color: #22252C;
          line-height: 20px;
          display: grid;
          grid-template-columns: 100px 1fr;
          align-items: center;
        }

        i {
          color: #5A5F6D99;
          font-size: 10px;
        }
      }
    }

    hr {
      margin: 12px 0;
      border-color: #F3F3F4;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 23px;
        color: #30333D;
      }

      &-actions {
        display: flex;
        align-items: center;

        .header-action {
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          margin-left: 16px;
          cursor: pointer;

          &.apply {
            color: #576CED;
          }

          &.clear {
            color: #5A5F6D99;
          }
        }
      }
    }
  }
</style>